<template>
  <module
    ref="module"
    id="funding-v2"
    titleIcon="fa fa-usd"
    :title="topUpTxt"
    :use-default-list="false"
    >
    <template slot="global" style="min-height: 60vh">
      <div class="row justify-content-center">
        <h4>
          <i class="fa fa-info-circle"></i>
          {{ $t('paymentinstructionsinfo') }}
        </h4>
      </div>
      <div class="row justify-content-md-center display-grid">
        <div class="display-grid mt-3">
          <span class="strong"> {{ $t('preferred_currency') }} </span>
          <el-select style="width: 25rem;"
            v-model="selectedCurrency"
            v-on:change="onSelectedCurrency"
            @keyup="onSelectedCurrency"
            >
            <template #prefix>
              <img v-if="selectedCurrency" :src="getSelectedFlag()" class="flag-icon mt-2" alt="flag" >
            </template>
            <el-option
              class="select-default"
              v-for="item in currencyList"
              :key="item.label"
              :label="item.label"
              :value="item.currency">
                <div class="option-content">
                  <img :src="item.flag" class="flag-icon" alt="flag">
                  <span class="ml-2"> {{ item.label }} </span>
                </div>
            </el-option>
          </el-select>
        </div>
        <div class="display-grid mt-3">
          <span class="strong"> {{ $t('depmethtxt') }} </span>
          <el-select  style="width: 25rem;"
            :disabled="!selectedCurrency"
            v-model="selectedMethod"
            @change="onMethodSelected">
            <el-option
              class="select-default"
              v-for="item in methodList"
              :key="item.label"
              :label="item.label"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row justify-content-md-center display-grid mt-4">
        <template v-if="selectedMethod == 'pix'">
          <pix-method
            :selected-currency="selectedCurrency"
          />
        </template>
        <template v-if="selectedMethod == 'smmoney'">
          <sr-money-method/>
        </template>
        <template v-if="selectedMethod == 'paypal'">
          <paypal-method
            :selected-currency="selectedCurrency"
          ></paypal-method>
        </template>
        <template v-if="selectedMethod && selectedCurrency == 'crypto'">
          <crypto-method
            :crypto="criptoDepositInfo"
          ></crypto-method>
        </template>
      </div>
      <template v-if="selectedMethod == 'transfer'">
            <transfer-method
              :transfer-options="transferOptions"
              :selected-currency="selectedCurrency"
            ></transfer-method>
        </template>
    </template>
  </module>

</template>
<script>
import {Input} from "element-ui";
import TransferMethod from "@/components/Dashboard/Views/Dashboard/Billing/Funding/transferMethod.vue";
import PaypalMethod from "@/components/Dashboard/Views/Dashboard/Billing/Funding/paypalMethod.vue";
import CryptoMethod from "@/components/Dashboard/Views/Dashboard/Billing/Funding/cryptoMethod.vue";
import PixMethod from "@/components/Dashboard/Views/Dashboard/Billing/Funding/pixMethod.vue";
import WalletOrder from "@/components/Dashboard/Views/Dashboard/Billing/WalletOrder.vue";
import SrMoneyMethod from "@/components/Dashboard/Views/Dashboard/Billing/Funding/srMoneyMethod.vue";
import {getCriptoList} from "@/util/CriptoHelper";
export default  {
  name: 'FundingV2',
  components: {
    SrMoneyMethod,
    WalletOrder,
    PixMethod,
    CryptoMethod,
    PaypalMethod,
    TransferMethod,
    [Input.name]: Input,
  },
  data() {
    return {
      topUpTxt: this.$t('topuptitle'),
      currencyList: [
        {
          label: '(USD) American Dollar',
          currency: 'usd',
          symbol: '$',
          flag: '/static/img/deposit_logos/USD.png',
          depositMethods: [
            {
              type: 'transfer',
              label: 'WIRE TRANSFER',
            },
            {
              type: 'paypal',
              label: 'PAYPAL',
            },
          ]
        },
        {
          label: '(BRL) Real Brasil',
          currency: 'brl',
          flag: '/static/img/deposit_logos/BRL.png',
          depositMethods: [
            {
              type: 'pix',
              label: 'Pix',
            },
            {
              type: 'smmoney',
              label: 'Sr Money',
            },
          ]
        },
        {
          label: '(EUR) Euro',
          currency: 'eur',
          symbol: '€',
          flag: '/static/img/deposit_logos/EUR.png',
          depositMethods: [
            {
              type: 'transfer',
              label: 'WIRE TRANSFER',
            },
            {
              type: 'paypal',
              label: 'PAYPAL',
            },
          ]
        },
        {
          label: 'Cripto',
          currency: 'crypto',
          flag: '/static/img/deposit_logos/CRYPTO.png',
          depositMethods: getCriptoList()
        }
      ],
      selectedMethod: '',
      selectedCurrency: '',
      methodList: '',
      fixedFee: 0,
      percentFee: 0,
      transferOptions: [],
      criptoDepositInfo: ''
    }
  },
  methods: {
    onSelectedCurrency() {
      this.selectedMethod = ''
        if(this.selectedCurrency) {
          let methods = this.currencyList.find( el => el.currency == this.selectedCurrency)
          this.methodList = methods.depositMethods
        } else {
          return ''
        }
    },
    getMethodFees() {
      if(this.selectedCurrency == 'crypto') {
        let cryptoInfo = this.methodList.filter( el => el.type == this.selectedMethod)
        this.criptoDepositInfo = cryptoInfo[0].depositInfo
      }
    },
    getSelectedFlag() {
       const country = this.currencyList.find(c => c.currency === this.selectedCurrency);
       return country ? country.flag : '';
    },
    async onMethodSelected() {
      this.getMethodFees()
    },
  },
  mounted() {
  },
}
</script>


<style scoped>
.option-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.flag-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #ddd;
}
.input .el-input__inner {
    margin-left: 15px;
  }
::v-deep(.el-select__prefix) .flag-icon {
  margin-right: 8px;
}
</style>
